import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SharedForm from "../../../../../widgets/SharedForm";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const SN_MAS_ORG_REG_003 = forwardRef(({ Menuprops }: Props, ref) => {
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any[]>([]);
  const [sharedForm, setSharedForm] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any>();
  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [selectedNode, setSelectedNode] = useState<any>();
  const [gridFocus, setGridFocus] = useState(false);

  // ref
  const searchRef = useRef<any>(null);
  const gridref1 = useRef<any>(null);
  const SharedFormref1 = useRef<any>();

  // golbal variable
  const { userInfo } = global();

  let SaveData: any = {};

  //#region grid 길이 관련
  const cd_menu = Menuprops.cd_menu || "SN_MAS_ORG_REG_003";
  const defaultSize = { panel1: "49.5%", panel2: "49.5%" };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setSharedForm(rtn.form.freeform1);
        setColums(rtn.grid.grid1);
      } catch (error: any) {
        await showDialog("error", error);
      }
    };
    fetchform();
  }, []);

  useEffect(() => {
    gridref1.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  //run whenever selectedNode is change
  useEffect(() => {
    if (selectedNode) {
      onFocusedRowChanged(selectedNode.data);
    }
  }, [selectedNode]);

  //region onSearch
  const onSearch = async () => {
    const modifiedRows1 = gridref1.current.getChange();
    if (modifiedRows1.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      const param = {
        id: "sn_mas_org_reg_003_01",
        params: searchRef.current.getFormdata(),
      };
      setFocusedRowData(0);
      setDataSource1([]);
      const data: any = await fnGetDataSet(param);
      setDataSource1(data[0]);
      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));
        gridref1.current.selectAndFocusRow(0);
      }
      gridref1.current.resetUpdate();
    } catch (error: any) {}
  };

  //region onInsert
  const onInsert = async () => {
    const newRow = {};
    if (gridref1.current) {
      await gridref1.current.addRow(newRow);
      setTimeout(() => {
        SharedFormref1.current.focusInputByIndex(0);
      }, 100);
    }
  };

  //region onBeforeAddRowH
  const onBeforeAddRowH = (newRow: RowData): boolean => {
    try {
      const selectedFormData = searchRef.current.getFormdata();
      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: selectedFormData.cd_biz_param,
        yn_use: "Y",
        fg_cc: "1",
      };
      Object.assign(newRow, updatedRow);
      return true;
    } catch (error: any) {
      return false;
    }
  };

  //region onDelete
  const onDelete = async () => {
    try {
      gridref1.current.deleteSelectedRows();
      await new Promise((resolve) => setTimeout(resolve, 50));
      const rowCount = gridref1.current?.api.getDisplayedRowCount();
      if (rowCount) {
        const selectedNode = gridref1.current?.api.getSelectedNodes()[0];
        setSelectedNode(selectedNode || null);
      } else setFocusedRowData(null);
      await onSave();
    } catch (error) {}
  };

  //region onSave
  const onSave = async () => {
    try {
      const requiredValuesCheckH = gridref1.current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }

      gridref1.current.api.stopEditing();
      const gridGetChanges = gridref1.current.getChange();
      const Inserts = gridGetChanges.insert ?? [];

      if (gridGetChanges.modifiedRowcount == 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      for (let row of Inserts) {
        if (row.cd_cc && row.cd_cc.length > 10) {
          await showDialog("alter", "창고가 10자리를 초과하였습니다.");
          return;
        }
      }

      for (let row of Inserts) {
        if (row.nm_cc && row.nm_cc.length > 50) {
          await showDialog("alter", "창고가 50자리를 초과하였습니다.");
          return;
        }
      }
      SaveData["mas_cc"] = gridGetChanges;
      await fnSave("SN_MAS_ORG_REG_003_SAVE_01", SaveData);
      gridref1.current.resetUpdate();
      SaveData = [];
    } catch (error: any) {}
  };

  //region onFocusedRowChanged
  const onFocusedRowChanged = useCallback(
    (focusedRowData: any | null) => {
      setFocusedRowData(focusedRowData || null);
    },
    [focusedRowData]
  );

  //region Return
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="w-full flex h-full min-h-0 space-x-1.5">
        <SnResizable
          direction={"width"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          minWidth={130}
          minHeight={130}
        >
          <SnGrid
            seq={1}
            ref={gridref1}
            
            enableAddRow={true}
            columnConfig={columns}
            rowData={dataSource1}
            enableExternalChart={false}
            isEditable={false}
            rowSelection="single"
            onFocusedRowChanged={onFocusedRowChanged}
            onBeforeAddRow={onBeforeAddRowH}
            cellSelection={false}
            resizeController={{
              defaultSize: defaultSize,
              onResizeStop: onResizeStop,
            }}
          />
        </SnResizable>
        <SnResizable
          direction={"width"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          minWidth={130}
          minHeight={130}
        >
          <SharedForm
            ref={SharedFormref1}
            data={focusedRowData}
            controls={sharedForm}
            gridref={gridref1}
            
          ></SharedForm>
        </SnResizable>
      </div>
    </div>
  );
});

export default SN_MAS_ORG_REG_003;
